<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" scrollable max-width="300px">
           
            <v-btn slot="activator" depressed flat class="caption font-weight-regular text-transform-none" color="#757575"
                :ripple="false">New <v-icon>chevron_right</v-icon>
            </v-btn>
            <v-card>
                <v-card-title>Select Condition</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-radio-group v-model="dialogm1" column>
                        <v-radio label="New" value="New"></v-radio>
                        <v-radio label="Used (like new)" value="Used (like new)"></v-radio>
                    </v-radio-group>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>

                    <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
    export default {
        props : {
            eventName : {
                type: String,
                default : 'selectCondition',
            }
        },
        name : 'ProductCondition',
        data() {
            return {
                dialogm1: '',
                dialog: false
            }
        },
        watch : {
            dialogm1 :{
                handler(newVal){
                  EventBus.$emit(this.eventName, {data : newVal});
                },
                deep : true,
            }
        }
    }
</script>